import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectAuthEmail } from 'src/app/state/auth.selectors';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AddShoppingCartItemRequest, AffiliateLinkActivityRecordRequest, ResultWrapper } from '../dtos/dto';
import { ConfigHelper } from './helpers/config.helper';
import { ShoppingCartService } from './shopping-cart.service';
import { AffiliateLinkActivityTypeEnum, BrandEnum } from 'src/app/core/dtos/enum';
import { resetStore } from 'src/app/state/reset-store.actions';
import { selectIsBusinessAccount } from 'src/app/state/my-account.selectors';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AffiliateService {

  affiliate: string;
  productId: number;
  AFFILIATE_COOKIE_NAME = 'affiliate-link-associate';
  AFFILIATE_COOKIE_PRODUCT = 'affiliate-link-associate-product';
  loggedInEmail$ = this.store.pipe(select(selectAuthEmail));
  loggedInEmail: string;
  businessAccountSubscription: Subscription;
  isBusinessAccount: boolean;
  private authSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private store: Store,
    private shoppingCartService: ShoppingCartService,
    private configHelper: ConfigHelper,
    private http: HttpClient,
  ) {
    this.route.queryParams
      .subscribe(params => {
        this.affiliate = params.affiliate;
        this.productId = Number(params.productId);
      });
  }

  logoutCurrentBusinessAccount() {
    this.businessAccountSubscription = this.store.select(selectIsBusinessAccount).pipe(take(1))
      .subscribe(
        (result) => {
          this.isBusinessAccount = result;
          if (this.isBusinessAccount == true) {
            this.store.dispatch(resetStore());
            sessionStorage.clear();
          }
        }
      );
  }

  checkAndInitAffiliateTracking() {
    if (this.affiliate === undefined) {
      this.affiliate = this.cookieService.get(this.AFFILIATE_COOKIE_NAME);
      if (this.affiliate === undefined) {
        return;
      }
    }
    // expired in 7 Days
    this.cookieService.set(this.AFFILIATE_COOKIE_NAME, this.affiliate, { path: "/", secure: false, expires: 7 });
    this.cookieService.set(this.AFFILIATE_COOKIE_PRODUCT, this.productId.toString(), { path: "/", secure: false, expires: 7 });

    //get product ID to add the product to the shopping cart
    const productId = this.cookieService.get(this.AFFILIATE_COOKIE_PRODUCT);
    if (productId !== undefined) {
      const product: AddShoppingCartItemRequest = {
        productId: this.productId,
      };
      this.shoppingCartService.addProduct(product);
    }

    // only track click activity once per session
    if (sessionStorage.RecordAffiliateForClick === undefined || sessionStorage.RecordAffiliateForClick == null || !sessionStorage.RecordAffiliateForClick) {
      //find and pass in userAccountId or account email if possible
      this.authSubscription = this.loggedInEmail$.subscribe({
        next: x => {
          this.loggedInEmail = x;
        }
      });
      if (this.affiliateCookieExist()) {
        this.recordAffiliateActivty(AffiliateLinkActivityTypeEnum.Click, null, null).subscribe((result) => { });
        sessionStorage.setItem('RecordAffiliateForClick', 'true');
      }
    }
  }

  recordAffiliateActivty(activityTypeId: number, userAccountId: number, userOrderId: number): Observable<ResultWrapper<string>> {
    var theCookie = this.cookieService.get(this.AFFILIATE_COOKIE_NAME);
    const request: AffiliateLinkActivityRecordRequest = {
      affiliateLinkGuid: theCookie,
      affiliateActivityTypeId: activityTypeId,
      userAccountId: userAccountId,
      userOrderId: userOrderId,
      userEmail: this.loggedInEmail
    };
    return this.http.post<ResultWrapper<string>>(this.configHelper.getApiUrl("Affiliate/RecordActivity"), request);
  }

  affiliateCookieExist(): boolean {
    var theCookie = this.cookieService.get(this.AFFILIATE_COOKIE_NAME);
    if (theCookie == "" || theCookie === undefined) {
      return false;
    }
    else {
      return true;
    }
  }
}
